var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06578 0C5.03585 0.0691687 4.03719 0.382836 3.15241 0.915047C2.26764 1.44726 1.52219 2.18271 0.977756 3.06056C0.433321 3.9384 0.105547 4.9334 0.0215571 5.96322C-0.0624333 6.99304 0.0997741 8.02808 0.494758 8.98269C0.889741 9.9373 1.50615 10.784 2.29297 11.4529C3.07979 12.1217 4.01441 12.5933 5.01949 12.8288C6.02457 13.0642 7.07122 13.0567 8.07283 12.8069C9.07445 12.5571 10.0022 12.0721 10.7794 11.3921L6.1958 6.80316C6.15464 6.76278 6.12194 6.71459 6.09962 6.6614C6.07729 6.60821 6.06579 6.55111 6.06578 6.49342V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3923 10.7778C12.4309 9.59293 13.0026 8.06976 13.0002 6.49342C13.0014 5.6295 12.8302 4.77404 12.4966 3.97726L7.2308 6.61228L11.3923 10.7778ZM12.1074 3.20159C11.5712 2.28592 10.8193 1.51547 9.91728 0.957426C9.0153 0.39938 7.99063 0.0706835 6.93262 0V5.7915L12.1074 3.20159Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.e887743ef8ef78e0d4fbc8232260f472.svg";
export { ForwardRef as ReactComponent };